import { render, staticRenderFns } from "./TiptapLinkButton.vue?vue&type=template&id=46315aef"
import script from "./TiptapLinkButton.vue?vue&type=script&lang=ts"
export * from "./TiptapLinkButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports